import {Language} from './i18nTypes';
import i18n from 'i18next';
import {getFromLocalStorage, storeToLocalStorage} from './utils/utils';
import {DEFAULT_LANGUAGE} from './config';

const PREFERRED_LANGUAGE = 'preferredUiLanguage';

export default function updateLanguageAction(newLanguage: Language) {
    i18n.changeLanguage(newLanguage)
    storeToLocalStorage(PREFERRED_LANGUAGE, JSON.stringify(newLanguage));
}

export const getCurrentLanguage = (): Language => {
    const language: string | null = getFromLocalStorage(PREFERRED_LANGUAGE);
    if (language && language !== 'undefined') {
        return JSON.parse(language);
    }
    const defaultLanguage = DEFAULT_LANGUAGE;
    setCurrentLanguage(defaultLanguage);
    return defaultLanguage;
};

export const setCurrentLanguage = (language: Language): void => {
    updateLanguageAction(language);
};
